export default "__VITE_ASSET__D__nh23Z__"